import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { Card } from "./Card";
import { GlassSurface } from "./GlassSurface";
import { FOCUS_TRANSITION } from "./focus";
import { gameLogo } from "./gameLogo";
export class GameCard extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._href = "";
        this._route = "video";
        this._title = "";
    }
    static _template() {
        const label = {
            fontFace: "Roboto",
            fontStyle: "400",
            fontSize: 20,
            precision: 1,
            h: 26,
            lineHeight: 26,
            offsetY: 20,
            textColor: 0xffffffff,
            textAlign: "center",
            wordWrap: false,
            textOverflow: "ellipsis",
            maxLinesSuffix: "…",
        };
        return {
            w: this.W,
            h: this.H,
            Background: {
                type: GlassSurface,
                w: (w) => w,
                h: (h) => h,
                glassOptions: {
                    radius: Card.BORDER_R,
                    bezelWidth: 30,
                    thickness: 30,
                    refraction: 0.27,
                    blur: 29,
                },
            },
            Date: { x: 31, y: 16.847, text: Object.assign(Object.assign({}, label), { w: 260 }) },
            HomeLogo: { x: 80.5, y: 90.347, mount: 0.5 },
            AwayLogo: { x: 241.5, y: 90.347, mount: 0.5 },
            HomeName: {
                x: 80,
                y: 139.85,
                mountX: 0.5,
                text: Object.assign(Object.assign({}, label), { w: 112 }),
            },
            AwayName: {
                x: 242,
                y: 139.85,
                mountX: 0.5,
                text: Object.assign(Object.assign({}, label), { w: 112 }),
            },
            LeagueLogo: {
                x: 146,
                y: 47,
                w: 30,
                h: 28,
                texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/ligue-1-symbol.svg"), 60, 56),
            },
            Kickoff: {
                x: 161,
                y: 75,
                mountX: 0.5,
                text: Object.assign(Object.assign({}, label), { w: 73, h: 41, fontFace: "Insatiable Display", fontStyle: "700", fontSize: 32, lineHeight: 41, offsetY: 32.4 }),
            },
            Status: {
                x: 161,
                y: 116,
                mountX: 0.5,
                flex: { direction: "row", alignItems: "center" },
                LiveIcon: {
                    w: 10,
                    h: 10,
                    texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/card-live.svg"), 20, 20),
                    flexItem: { marginRight: 4 },
                },
                Label: {
                    text: Object.assign(Object.assign({}, label), { fontSize: 14.04, h: 18, lineHeight: 18, offsetY: 14 }),
                },
            },
            Border: {
                color: 0xffffffff,
                alpha: 0,
                texture: Card.borderTexture(this.W, this.H),
            },
        };
    }
    static get width() {
        return this.W;
    }
    static get height() {
        return this.H;
    }
    static get marginRight() {
        return Card.marginRight;
    }
    set item(item) {
        var _a, _b, _c, _d, _e, _f, _g;
        this._title = `${item.home.name} vs ${item.away.name}`;
        this._href = (_a = item.href) !== null && _a !== void 0 ? _a : "";
        this._route = (_b = item.route) !== null && _b !== void 0 ? _b : "video";
        this.patch({
            Date: { text: { text: item.date } },
            Kickoff: { text: { text: item.kickoff } },
            HomeLogo: Object.assign(Object.assign({}, gameLogo(item.home.logoSrc, item.home.logoWidth, item.home.logoHeight)), { w: item.home.logoWidth, h: item.home.logoHeight }),
            AwayLogo: Object.assign(Object.assign({}, gameLogo(item.away.logoSrc, item.away.logoWidth, item.away.logoHeight)), { w: item.away.logoWidth, h: item.away.logoHeight }),
            HomeName: {
                text: {
                    text: (_c = item.home.shortName) !== null && _c !== void 0 ? _c : item.home.name,
                    w: (_d = item.home.nameWidth) !== null && _d !== void 0 ? _d : 112,
                },
            },
            AwayName: {
                text: {
                    text: (_e = item.away.shortName) !== null && _e !== void 0 ? _e : item.away.name,
                    w: (_f = item.away.nameWidth) !== null && _f !== void 0 ? _f : 112,
                },
            },
            Status: {
                LiveIcon: { visible: !!item.live },
                Label: {
                    text: { text: item.live ? "LIVE" : ((_g = item.timezone) !== null && _g !== void 0 ? _g : "CEST") },
                },
            },
        });
    }
    _focus() {
        this.tag("Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        if (this._route.startsWith("subscribe/")) {
            Router.navigate(this._route);
        }
        else if (this._href)
            Router.navigate(this._route, Object.assign({ href: this._href }, (this._route === "video" && {
                title: this._title,
                category: "Live & Upcoming Games",
            })));
        return true;
    }
}
GameCard.W = Card.W;
GameCard.H = Card.H_NO_DESC;
export default GameCard;
//# sourceMappingURL=GameCard.js.map